module.exports = __webpack_public_path__ + "static/img/wild1.1e4e6ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wlzb/wild1.png
// module id = /FpX
// module chunks = 0